import { ShippingOptionProps } from './shipping-option.types'
import styles from './shipping-option.module.scss'
import cl from 'classnames'
import { HorizontalLine } from '@touche-lts/panel-ui/dist'
// import { ValueTag } from 'components'
import { ShippingOptionView } from './shipping-option-view'
import { ShippingOptionEdit } from './shipping-option-edit'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'

const ShippingOptionComponent = (props: ShippingOptionProps) => {
  const { className, style, shipping, isLastInList } = props
  const {
    storeShippingsStore: {
      isShippingInEditMode,
      onEditShippingClick,
      onRemoveShippingClick
    }
  } = useRootStore()

  const editMode = isShippingInEditMode(shipping.id)

  return (
    <div className={cl(styles.container, className)} style={style}>
      {editMode ? (
        <ShippingOptionEdit />
      ) : (
        <ShippingOptionView
          shipping={shipping}
          onEditClick={() => onEditShippingClick(shipping.id)}
          onRemoveClick={() => onRemoveShippingClick(shipping.id)}
        />
      )}
      {!(isLastInList && editMode) && <HorizontalLine colorPreset='dark' />}
    </div>
  )
}

const ShippingOption = observer(ShippingOptionComponent)
export { ShippingOption }
